import { PhoneNumberUtil } from 'libphonenumber';

export default (function (LocaleService) {

    return {
        /**
         * Will pretty-print a phone number according
         * to the provided region
         *
         * If number is not valid or libphonenumber is absent
         * will return an original string
         *
         * @param {String} phoneNumber
         * @param {String} countryCode
         * @returns {String}
         */
        prettyPrint: function prettyPrint(phoneNumber, countryCode) {
            var phoneUtils = PhoneNumberUtil.getInstance();
            var phoneRegion = countryCode || LocaleService.getConfiguredPhoneRegion();
            try {
                return phoneUtils.format(phoneUtils.parse(phoneNumber, phoneRegion));
            } catch (e) {
                // if there is some problem in libphonenumber e.g. the number is not valid
                // returns the original number
                return phoneNumber;
            }
        },
        isPossibleNumber: function isPossibleNumber(propertyValue, countryCode) {
            var phoneUtils = PhoneNumberUtil.getInstance();
            var returnVal = true;
            var extPos = void 0;
            var number = void 0;
            if (angular.isDefined(propertyValue) && propertyValue !== null && propertyValue !== '') {
                extPos = propertyValue.indexOf(' x');
                number = extPos > 0 ? propertyValue.substring(0, extPos) : propertyValue;
                number = number.replace(/[-_]/g, '');
                try {
                    returnVal = phoneUtils.isPossibleNumber(phoneUtils.parse(number, countryCode || LocaleService.getConfiguredPhoneRegion()));
                } catch (e) {
                    return false; // Suppress log error message from libphonenumber when number is not valid
                }
            }
            return returnVal;
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-angular/PhoneUtil.js
// module id = 305
// module chunks = 0